import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_2 = { class: "p-field p-col p-col-12 p-md-4 p-lg-3" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", null, "Chọn khoản thời gian thống kê: ", -1)
const _hoisted_4 = {
  key: 0,
  class: "p-field p-col p-col-12 p-md-4 p-lg-2"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", null, "Hiển thị doanh thu:", -1)
const _hoisted_6 = { class: "p-field p-col p-col-12 p-md-12 p-lg-12" }
const _hoisted_7 = { class: "p-field p-col p-col-12 p-md-12 p-lg-12" }
const _hoisted_8 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_9 = { class: "p-field p-col p-col-12 p-md-4 p-lg-3" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", null, "Tổng doanh thu", -1)
const _hoisted_11 = { class: "p-field p-col p-col-12 p-md-4 p-lg-3" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", null, "Tổng chi phí", -1)
const _hoisted_13 = { class: "p-field p-col p-col-12 p-md-4 p-lg-3" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", null, "Tổng lợi nhuận", -1)
const _hoisted_15 = {
  class: "p-field p-col p-col-12 p-md-4 p-lg-3",
  style: {"color":"red"}
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", null, "Tổng tiền nợ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Toast = _resolveComponent("Toast")!
  const _component_ConfirmPopup = _resolveComponent("ConfirmPopup")!
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_Panel = _resolveComponent("Panel")!
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_AccordionTab = _resolveComponent("AccordionTab")!
  const _component_Accordion = _resolveComponent("Accordion")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Toast),
    _createVNode(_component_ConfirmPopup),
    _createVNode(_component_Accordion, { activeIndex: 0 }, {
      default: _withCtx(() => [
        _createVNode(_component_AccordionTab, {
          header: "TRA CỨU DOANH THU",
          style: {"font-weight":"bold"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_Panel, { header: "" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, [
                  _createElementVNode("div", _hoisted_2, [
                    _hoisted_3,
                    _createVNode(_component_Calendar, {
                      id: "date",
                      modelValue: $setup.date,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.date) = $event)),
                      selectionMode: "range",
                      dateFormat: "dd/mm/yy",
                      showButtonBar: true,
                      showIcon: true,
                      manualInput: false,
                      monthNavigator: true,
                      yearNavigator: true,
                      yearRange: "2000:2100",
                      onDateSelect: _cache[1] || (_cache[1] = ($event: any) => ($setup.selectCalendar())),
                      onClearClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.clearCalendar()))
                    }, null, 8, ["modelValue"])
                  ]),
                  ($setup.listHoaDon.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                        _hoisted_5,
                        _createVNode(_component_Button, {
                          label: "Xem",
                          class: "btn-spa-add",
                          icon: "pi pi-eye",
                          iconPos: "left",
                          onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.clickDoanhThu()))
                        })
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_6, [
                    _createVNode(_component_DataTable, {
                      value: $setup.listHoaDon,
                      showGridlines: true,
                      paginator: true,
                      stripedRows: "",
                      rows: 10,
                      rowsPerPageOptions: [10,25,50],
                      rowHover: true,
                      dataKey: "id",
                      paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown",
                      currentPageReportTemplate: "Có tổng số {totalRecords} lượt mua",
                      columnResizeMode: "fit"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_Column, {
                          header: "Stt",
                          headerStyle: "width:3rem"
                        }, {
                          body: _withCtx((slotProps) => [
                            _createTextVNode(_toDisplayString(slotProps.index + 1), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_Column, {
                          field: "tenKhachHang",
                          header: "Khách hàng",
                          sortable: ""
                        }),
                        _createVNode(_component_Column, {
                          field: "giaBan",
                          header: "Giá bán",
                          sortable: ""
                        }, {
                          body: _withCtx(({data}) => [
                            _createTextVNode(_toDisplayString($setup.formatCurrency(data.giaBan)), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_Column, {
                          field: "giamGia",
                          header: "Giảm giá (%)",
                          sortable: ""
                        }),
                        _createVNode(_component_Column, {
                          field: "giaThucThu",
                          header: "Giá thực thu",
                          sortable: ""
                        }, {
                          body: _withCtx(({data}) => [
                            _createTextVNode(_toDisplayString($setup.formatCurrency(data.giaThucThu)), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_Column, {
                          field: "soTienDaThu",
                          header: "Số tiền đã thu",
                          sortable: ""
                        }, {
                          body: _withCtx(({data}) => [
                            _createTextVNode(_toDisplayString($setup.formatCurrency(data.soTienDaThu)), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_Column, {
                          field: "soTienNo",
                          header: "Số tiền nợ",
                          style: {"font-weight":"bold","color":"red"},
                          sortable: ""
                        }, {
                          body: _withCtx(({data}) => [
                            _createTextVNode(_toDisplayString($setup.formatCurrency(data.soTienNo)), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_Column, {
                          field: "thoiGianThuTien",
                          dataType: "date",
                          header: "Thời gian tạo",
                          sortable: ""
                        }, {
                          body: _withCtx(({data}) => [
                            _createTextVNode(_toDisplayString($setup.formatDateTime(data.thoiGianThuTien)), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_Column, {
                          field: "nguoiThucHien",
                          header: "Người tạo",
                          sortable: ""
                        }),
                        _createVNode(_component_Column, {
                          field: "thoiGianCapNhat",
                          dataType: "date",
                          header: "Thời gian cập nhật",
                          sortable: ""
                        }, {
                          body: _withCtx(({data}) => [
                            _createTextVNode(_toDisplayString($setup.formatDateTime(data.thoiGianCapNhat)), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_Column, {
                          field: "nguoiCapNhat",
                          header: "Người cập nhật",
                          sortable: ""
                        })
                      ]),
                      _: 1
                    }, 8, ["value"])
                  ])
                ])
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_Dialog, {
                visible: $setup.showDoanhThu,
                "onUpdate:visible": _cache[8] || (_cache[8] = ($event: any) => (($setup.showDoanhThu) = $event)),
                modal: "",
                blockScroll: "",
                style: { width: '70vw'},
                breakpoints: { '1500px': '50vw', '1150px': '70vw', '800px': '80vw' }
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_Panel, { header: "Chi tiết doanh thu" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("div", _hoisted_9, [
                          _hoisted_10,
                          _createVNode(_component_InputNumber, {
                            id: "tongGiaBan",
                            type: "text",
                            modelValue: $setup.doanhThu.tongGiaBan,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.doanhThu.tongGiaBan) = $event)),
                            inputId: "integeronly",
                            readonly: ""
                          }, null, 8, ["modelValue"])
                        ]),
                        _createElementVNode("div", _hoisted_11, [
                          _hoisted_12,
                          _createVNode(_component_InputNumber, {
                            id: "tongGiaNhap",
                            type: "text",
                            modelValue: $setup.doanhThu.tongGiaNhap,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.doanhThu.tongGiaNhap) = $event)),
                            inputId: "integeronly",
                            readonly: ""
                          }, null, 8, ["modelValue"])
                        ]),
                        _createElementVNode("div", _hoisted_13, [
                          _hoisted_14,
                          _createVNode(_component_InputNumber, {
                            id: "tongLoiNhuan",
                            type: "text",
                            modelValue: $setup.doanhThu.tongLoiNhuan,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.doanhThu.tongLoiNhuan) = $event)),
                            inputId: "integeronly",
                            readonly: ""
                          }, null, 8, ["modelValue"])
                        ]),
                        _createElementVNode("div", _hoisted_15, [
                          _hoisted_16,
                          _createVNode(_component_InputNumber, {
                            id: "tongTienNo",
                            type: "text",
                            modelValue: $setup.doanhThu.tongTienNo,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.doanhThu.tongTienNo) = $event)),
                            inputId: "integeronly",
                            inputStyle: "color: red; font-weight: bold",
                            readonly: ""
                          }, null, 8, ["modelValue"])
                        ])
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["visible"])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}